import React from 'react';
import cn from 'classnames';
import {Link, NavLink, useHistory, useLocation} from 'react-router-dom';
import {GlobalLocationTypes} from '../../../utils/types';
import {useLockScrollBody} from '../../../utils/hooks';
import {PATHS} from '../../../Routes';
import StyledIcon from '../StyledIcon';
import {Icon} from '../Icon';
import styles from './MobileNavigation.module.sass';

export type LinkItem = {
  route: string;
  label: string;
  disabled?: boolean;
};

export type CheckinNavigationProps = {
  links?: LinkItem[];
  extraLinks?: LinkItem[];
  title?: string;
  showHomeButton?: boolean;
  showMenuButton?: boolean;
  className?: string;
};

const defaultProps: CheckinNavigationProps = {
  title: '',
  showHomeButton: false,
  showMenuButton: true,
};

function MobileNavigation({
  title,
  links,
  extraLinks,
  showHomeButton,
  showMenuButton,
  className,
}: CheckinNavigationProps) {
  const history = useHistory();
  const location = useLocation<GlobalLocationTypes>();
  const [open, setOpen] = React.useState<boolean>(false);
  useLockScrollBody(open);

  return (
    <>
      <div className={cn(className, styles.container)}>
        <div className={styles.navBackButton}>
          <Icon
            title="Back"
            name="arrow-left"
            className={styles.arrowLeft}
            size="16"
            onClick={history.goBack}
          />
        </div>
        <div className={styles.navTitle}>{title}</div>
        {showHomeButton && (
          <Link to={PATHS.home} className={styles.homeButton}>
            <StyledIcon
              className={styles.homeIcon}
              name="accountMenuHome"
              size="31px"
              color="#6b6b95"
            />
          </Link>
        )}
        {showMenuButton && (
          <div className={styles.navMenuToggle} onClick={() => setOpen(!open)}>
            {open ? (
              <Icon title="Close" name="close" className={styles.close} size="24" />
            ) : (
              <Icon title="Menu" name="map-menu" className={styles.mapMenu} size="24" />
            )}
          </div>
        )}
      </div>
      {open && (
        <div className={styles.burgerMenuLinks}>
          <div className={styles.burgerMenuCloseButton} onClick={() => setOpen(!open)}>
            <Icon title="Close" name="close" size="28" />
          </div>
          {links?.map(({route, label, disabled}, i) => {
            if (disabled) {
              return (
                <div key={i} className={styles.disabled}>
                  <span className={styles.burgerMenuLink}>{label}</span>
                </div>
              );
            }
            return (
              <NavLink
                className={styles.wrapperMobileNavLink}
                key={i}
                to={{pathname: route, state: location.state}}
                activeClassName={styles.activeLink}
                onClick={() => setOpen(false)}
              >
                <span className={styles.burgerMenuLink}>{label}</span>
              </NavLink>
            );
          })}
          {Boolean(extraLinks?.length) && <div className={styles.horizontalLine} />}
          {extraLinks?.map(({route, label}, i) => {
            return (
              <NavLink
                key={i}
                to={{pathname: route, state: location.state}}
                activeClassName={styles.activeLink}
                onClick={() => setOpen(false)}
              >
                <span className={styles.burgerMenuLink}>{label}</span>
              </NavLink>
            );
          })}
        </div>
      )}
    </>
  );
}

MobileNavigation.defaultProps = defaultProps;

export {MobileNavigation};
